import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../Layout/BRSRSidebar";
import SectionA from "./SectionA";

const index = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <SectionA />
    </MainDashboardLayout>
  );
};

export default index;
